import { AutenticationEventType } from './../../autentication/autentication.event.type';
import { Auth } from './../../autentication/Auth';
import { AppEventDispatcher } from './../../utils/AppEventDispatcher';
import { EventTypes } from './../EventTypes';
import { Component, OnInit, OnDestroy, ViewEncapsulation, Input } from '@angular/core';
import { TweenMax, Power2, Quint } from 'gsap';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { ThemeService } from '../theme-service/theme.service';
import { Util } from '../../utils/util';
import { MainMenu } from '../models/main-menu.model';
import { LimiteGlobalService } from '../../master/limite-global/limite-global.service';
import { finalize, take } from 'rxjs/operators';
import { MatDialog } from '@angular/material';
import { ModalAvisoFinanciamentoLgComponent } from '../../master/limite-global/components/modal-aviso-financiamento-lg/modal-aviso-financiamento-lg.component';
import { ModalTermsComponent } from '../modal-terms/modal-terms.component';
import * as moment from 'moment';
import { SharedModalInfoComponent } from '../modal-info/modal-info.component';
import { ModalConfirmComponent } from '../modal-confirm/modal-confirm.component';

@Component({
	selector: 'app-main-menu',
	templateUrl: './main-menu.component.html',
	styleUrls: ['./main-menu.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class MainMenuComponent implements OnInit, OnDestroy {
	public themeConfigs: any;
	public primaryColor: any;
	public isOpenBank: boolean;
	public isAttendant: boolean;
	public hasLimiteGlobal: boolean;
	public scrollbarOptions = { axis: 'y', scrollButtons: { enable: true } };
	public href = '';
	public showCreditCard = false;

	rule: string;

	menus: MainMenu;

	constructor(
		private router: Router,
		private themeService: ThemeService,
		private limiteGlobalService: LimiteGlobalService,
		private dialog: MatDialog,
	) {

		this.themeConfigs = this.themeService.getThemeConfigs();
		this.isAttendant = this.themeConfigs.isAttendant;
		this.isOpenBank = this.themeConfigs.isOpenBank;
		this.primaryColor = this.themeConfigs.CorPrimaria ? this.themeConfigs.CorPrimaria : '';
		this.menus = Util.keysToCamel(this.themeConfigs.Menus) as MainMenu;

		AppEventDispatcher.listen( EventTypes.MENU.TOGGLE, (data) => {
			if (data.open) {
				TweenMax.to('[data-component="main-menu"]', .7, {
					left: '0',
					ease: Power2.easeOut
				});
			} else {
				TweenMax.to('[data-component="main-menu"]', .7, {
					left: '-100%',
					ease: Power2.easeOut
				});
			}
		});

		AppEventDispatcher.listen( EventTypes.MENU.CHANGE, (data) => {
			if (data.show) {
				this.show();
			}
		});

	}

	get showChargeMenu(): boolean{
		return Auth.getInstance().getUser().personType !== 'F';
	}

	show() {
		if (Auth.getInstance().getUser()) {
			this.rule = Auth.getInstance().getUser().rule;
			const accountType = Auth.getInstance().getUser().accountType;
			// this.menus.Investimento = accountType === 5 ? false : true;
		}

		this.router.events.subscribe((val) => {
			if (val instanceof NavigationEnd) {
				setTimeout(() => {
					$('.list-menu .item-menu').each(function() {
						if (!$(this).hasClass('active')) {
							TweenMax.to($(this).find('.list-submenu'), .5, {
								height: 0,
								ease: Quint.easeOut,
							});

							TweenMax.to($(this).find('.item-arrow'), .4, {
								rotation: 0,
								ease: Quint.easeOut
							});

							$(this).find('.list-submenu').removeClass('active');
						}
					});
				}, 0);
			}
		});
	}



	animationIn(e) {
		const animation = e.currentTarget.querySelectorAll('.list-menu .animationLayer');
		const	animationSubmenu = e.currentTarget.querySelectorAll('.list-submenu .animationLayer');

		TweenMax.to(animation, .9, {
			width: '150%',
			ease: Power2.easeOut
		});

		TweenMax.to(animationSubmenu, .5, {
			width: '100%',
			height: '100%',
			ease: Power2.easeOut
		});
	}

	animationOut(e) {
		const animation = e.currentTarget.querySelectorAll('.list-menu .animationLayer');
		const	animationSubmenu = e.currentTarget.querySelectorAll('.list-submenu .animationLayer');

		TweenMax.to(animation, .7, {
			width: 0,
			ease: Power2.easeOut
		});

		TweenMax.to(animationSubmenu, .5, {
			width: 0,
			height: 0,
			ease: Power2.easeOut
		});
	}

	itemOpen(e) {
		const itemMenu = e.currentTarget;
		const anyItemMenu = e.nextElementSibling;
		const submenu = e.currentTarget.nextElementSibling;

		if (submenu) {

			if (submenu.classList.contains('active') || $(submenu).height() > 0) {
				this.itemClose();
			} else {
				this.itemClose();

				TweenMax.delayedCall(.4, () => {
					TweenMax.set(submenu, {
						height: 'auto'
					});

					TweenMax.from(submenu, .5, {
						height: 0,
						ease: Quint.easeIn,
					});

					TweenMax.to(itemMenu.querySelectorAll('.item-arrow'), .4, {
						rotation: 90,
						ease: Quint.easeIn
					});
				});

				submenu.classList.add('active');
			}
		}
	}

	itemClose() {
		TweenMax.to($('.item-arrow'), .4, {
			rotation: 0,
			ease: Quint.easeOut
		});

		TweenMax.to($('.list-submenu'), .4, {
			height: 0,
			ease: Quint.easeOut
		});

		$('.list-submenu').removeClass('active');
	}

	checkMessageClientsLeaks() {
		setTimeout(() => {

		const alreadyClose = localStorage.getItem('leakMsg') === this.userCpfCnpj ? true : false;
		const userCpfCnpjs = ['03415808130', '95415670459', '41963878884'];

		if (!alreadyClose && userCpfCnpjs.find(cpf => cpf === this.userCpfCnpj)) {
			const dialogRef = this.dialog.open(ModalTermsComponent, {
				width: '700px',
				height: '440px',
				disableClose: true,
				data: {
					backButtonName: 'Entendi',
					title: 'Comunicado Importante',
					text: `
					<div style="text-align: justify;">
						Prezado cliente, <br><br> Por solicitação do Banco Central do Brasil,
						informamos que pessoa não autorizada teve acesso a alguns de seus dados cadastrais por meio de uma falha tecnológica em outro banco.
						Fique tranquilo, pois NÃO foram acessadas senhas ou dados financeiros (movimentações e saldos) e as informações NÃO permitem acesso a suas contas ou a
						realização de transações financeiras em seu nome. Porém, fique atento para não cair em golpes. Esta será a única mensagem ou contato que você receberá
						sobre esse caso. O Banco Central do Brasil ou os bancos NÃO lhe enviarão outra comunicação NEM pedirão para você fornecer ou confirmar informações.
						Para saber mais detalhes, acesse o Comunicado integral no seguinte endereço:
						<p class="link_com">
						<a  href="https://www.bcb.gov.br/content/estabilidadefinanceira/pix/BC_comunica_ocorrencia_Pix-2.pdf" target="blank">https://www.bcb.gov.br/content/estabilidadefinanceira/pix/BC_comunica_ocorrencia_Pix-2.pdf</a>
						</p>
					</div>
					`
				}
			});

			dialogRef.afterClosed().subscribe((data: boolean) => {
				if (data) {
					localStorage.setItem('leakMsg', this.userCpfCnpj);
				}
			});
		}

		}, 1000);
	}

	ngOnInit() {
		this.checkMessageClientsLeaks();

		setTimeout(() => {
			$('.list-menu .item-menu').each(function() {
				if ($(this).hasClass('active') && $(this).find('.list-submenu').length) {
					$(this).find('.list-submenu').height('auto');
					$(this).find('.item-arrow').css('transform', 'translateY(-50%) rotate(90deg)');
				}
			});
		}, 0);

		this.getStatusLimiteGlobal();
	}

	private loaderLimiteGlobal(active: boolean): void {
		AppEventDispatcher.dispatch(EventTypes.PRELOAD, {
			element: '[data-component="limite-global"] .content',
			show: active,
			delay: 1,
		});
	}

	private getStatusLimiteGlobal(): void {
		this.loaderLimiteGlobal(true);
		this.limiteGlobalService
			.getGlobalLimitStatus()
			.pipe(
				finalize(() => this.loaderLimiteGlobal(false)),
				take(1)
			)
			.subscribe(
				(res) => {
					if (res && res.Retorno) {
						this.hasLimiteGlobal = !!res.Retorno.LimiteGlobal;
						if (this.hasLimiteGlobal && this.limiteGlobalService.canShowModal) {
							this.dialog.open(ModalAvisoFinanciamentoLgComponent, {
								width: '410px',
								height: '450px'
							});
						}
					}
				},
				(error) => {
					AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, {
						msg: error.error.Mensagem,
					});
				}
			);
	}

	openSystemMaintenceAlert(e){
		const actualDate = new Date();
		const startMaintenceDate = '2023-06-29';
		if(moment(actualDate).isAfter(moment(startMaintenceDate))){
			this.dialog.open(SharedModalInfoComponent, {
				width: '360px',
				data: {
					title: 'Sistema de boleto em manutenção no sistema financeiro nacional!',
					//text: 'Você já possui uma solicitação em andamento. Em caso de dúvidas, entre em contato com nossa Central de Relacionamento.',
					btnName: 'Entendi',
				}
			});
		  return
		}
	  
		this.itemOpen(e) 
	  }

	openDeviceManagementNotice(event: MouseEvent): void {
		event.preventDefault();
		event.stopPropagation();

		this.dialog.open(ModalConfirmComponent, {
			width: '350px',
			data: {
				title: 'Disponível apenas no aplicativo Omni',
				text: 'Acesse seu app Omni para cadastrar, gerenciar ou autorizar dispositivos vinculados à sua conta.',
				hideBackButton: true,
				confirmButton: 'Entendi',
			}
		});
	}

	ngOnDestroy() {
		AppEventDispatcher.removeListener( EventTypes.MENU.TOGGLE );
		AppEventDispatcher.removeListener( EventTypes.MENU.CHANGE );
		AppEventDispatcher.removeListener(AutenticationEventType.ACCOUNT.CHANGE_ACCOUNT_MENU);
	}

	get isCnpj(): boolean { return Auth.getInstance().getUser().personType === 'J'; }
	get userName(): string { return Auth.getInstance().getUser().loggedUserName; }
	get userCpfCnpj(): string { return Auth.getInstance().getUser().cpfCnpj; }
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/shared/main-menu/main-menu.component.ts